import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import helpers from '@/helpers';
import config from '@/config';
import Permissions from '@/mixins/permission.js';
import { HTTP } from '@/http';
import VueMeta from 'vue-meta';
import '@mdi/font/css/materialdesignicons.css'

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { VueMaskDirective } from 'v-mask';
import money from 'v-money';
import Print from 'vue-print-nb';

import Vue2Filters from 'vue2-filters';
var Vue2FiltersConfig = {
  currency: {
    symbol: '',
    decimalDigits: 0,
    thousandsSeparator: '.',
    symbolOnLeft: false
  },
}

import * as  VueGoogleMaps from "vue2-google-maps";
import 'leaflet/dist/leaflet.css';
import './registerServiceWorker'

Vue.directive('mask', VueMaskDirective);
Vue.use(VueQuillEditor);
Vue.use(money, {precision: 4});
Vue.mixin(Permissions);
Vue.use(Print);
Vue.use(VueGoogleMaps);
Vue.use(Vue2Filters, Vue2FiltersConfig);
Vue.use(VueMeta);

VueGoogleMaps.loadGmapApi({
  key: config.gmap.key,
  libraries: config.gmap.libraries,
});

const plugins = {
  install() {
    Vue.prototype.$helpers = helpers;
  }
}
Vue.use(plugins);

window.axios = HTTP;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');